var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header", {
        attrs: {
          role: _vm.role,
          authorities: _vm.authorities,
          streamData: _vm.streamData,
        },
      }),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-col",
            { staticClass: "ma-0 pa-1 pt-7 mb-7", attrs: { cols: "12" } },
            [
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 text-left", attrs: { cols: "12" } },
                [_vm._v(_vm._s(_vm.tmb("msgVideoDownload")))]
              ),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 text-left", attrs: { cols: "12" } },
                [_vm._v(_vm._s(_vm.tmb("until100hour")))]
              ),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mt-2 mb-6",
                  attrs: { id: "download_info_box", cols: "12" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-4 text-left",
                      attrs: { cols: "12" },
                    },
                    [_vm._v(_vm._s(_vm.tmb("createDownloadFile")))]
                  ),
                  _c("v-divider", {
                    staticClass: "ma-0 pa-0",
                    attrs: { id: "middle_divider" },
                  }),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-4 pl-7 pr-7",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 text-left",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s(_vm.tmb("remainTime")))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pl-2 text-left",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s(_vm.remainingTimeStr))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 text-left",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s(_vm.tmb("totalTime")))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pl-2 text-left",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s(_vm.usedTimeStr))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 mt-7 text-left",
                          attrs: { cols: "12" },
                        },
                        [_vm._v(_vm._s(_vm.tmb("durationTime")))]
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0 mt-1",
                          attrs: { align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pl-4 text-left",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s("開始日時："))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 mr-2",
                              attrs: { cols: "2" },
                            },
                            [
                              _c("CustomDatePicker", {
                                attrs: {
                                  viewCalendarIcon: false,
                                  viewTextField: true,
                                  initDate: false,
                                  time: false,
                                  disableFuture: true,
                                  fontSize: "1rem",
                                  recordingCkeck: true,
                                  recordingPeriod: _vm.recordingPeriod,
                                },
                                on: { resultDate: _vm.startDateFunc },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              staticStyle: { width: "5rem" },
                              attrs: { cols: "auto" },
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  "background-color": "#272727",
                                  dark: "",
                                  items: _vm.hourList,
                                  dense: "",
                                  "hide-details": "",
                                  outlined: "",
                                  "item-text": "label",
                                  "item-value": "value",
                                },
                                model: {
                                  value: _vm.selectedHour,
                                  callback: function ($$v) {
                                    _vm.selectedHour = $$v
                                  },
                                  expression: "selectedHour",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s("："))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              staticStyle: { width: "5rem" },
                              attrs: { cols: "auto" },
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  "background-color": "#272727",
                                  dark: "",
                                  items: _vm.minuteList2,
                                  dense: "",
                                  "hide-details": "",
                                  outlined: "",
                                  "item-text": "label",
                                  "item-value": "value",
                                },
                                model: {
                                  value: _vm.selectedMinute,
                                  callback: function ($$v) {
                                    _vm.selectedMinute = $$v
                                  },
                                  expression: "selectedMinute",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0 mt-1",
                          attrs: { align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pl-4 text-left",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s("録画時間："))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              staticStyle: { width: "8rem" },
                              attrs: { cols: "auto" },
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  "background-color": "#272727",
                                  dark: "",
                                  items: _vm.minuteList,
                                  dense: "",
                                  "hide-details": "",
                                  outlined: "",
                                  "item-text": "label",
                                  "item-value": "value",
                                },
                                model: {
                                  value: _vm.selectedDownloadMinute,
                                  callback: function ($$v) {
                                    _vm.selectedDownloadMinute = $$v
                                  },
                                  expression: "selectedDownloadMinute",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 mt-7 text-left",
                          attrs: { cols: "12" },
                        },
                        [_vm._v(_vm._s(_vm.tmb("msgDataName")))]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 mt-2 text-left",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { align: "center" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 text-left",
                                  attrs: { cols: "8" },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.userInputDataName,
                                        expression: "userInputDataName",
                                      },
                                    ],
                                    staticClass: "name_input",
                                    staticStyle: {
                                      width: "80%",
                                      height: "2.5rem",
                                    },
                                    domProps: { value: _vm.userInputDataName },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.userInputDataName =
                                            $event.target.value
                                        },
                                        _vm.validateMaxInput,
                                      ],
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showMaxError,
                                          expression: "showMaxError",
                                        },
                                      ],
                                      staticClass: "error-message",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.tmb("msgErrorMaxCharacters"))
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showInvalidCharacter,
                                          expression: "showInvalidCharacter",
                                        },
                                      ],
                                      staticClass: "error-message",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.tmb("msgErrorFileName"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 text-right",
                                  attrs: { cols: "4" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-0 pa-2",
                                      attrs: {
                                        width: "8rem",
                                        height: "auto",
                                        id: "blue_btn",
                                        elevation: "0",
                                      },
                                      on: { click: _vm.confirmFunc },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.t("create")) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mb-2 text-left",
                  attrs: { cols: "12" },
                },
                [_vm._v(_vm._s(_vm.tmb("msgDownloadFileList")))]
              ),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-2",
                  attrs: { id: "table_header", cols: "12" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 text-left",
                          attrs: { cols: "4" },
                        },
                        [_vm._v(_vm._s(_vm.tmb("titleDownloadFile")))]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 text-left",
                          attrs: { cols: "4" },
                        },
                        [_vm._v(_vm._s(_vm.tmb("titleDurationTime")))]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 text-left",
                          attrs: { cols: "4" },
                        },
                        [_vm._v(_vm._s(_vm.tmb("titleDurationPreserve")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { id: "table_body", cols: "12" },
                },
                [
                  _vm.downloadDataList.length > 0
                    ? _vm._l(_vm.downloadDataList, function (item, index) {
                        return _c(
                          "v-col",
                          {
                            key: index,
                            staticClass: "ma-0 pa-0",
                            attrs: { cols: "12" },
                          },
                          [
                            _c("DownloadDataListItem", {
                              attrs: { item: item },
                              on: { deleteSuccess: _vm.deleteSuccessFunc },
                            }),
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("DownloadConfirmDialog", {
        attrs: {
          dialogVisible: _vm.downloadConfirmDialogVisible,
          params: _vm.params,
          streamData: _vm.streamData,
          downloadTime: _vm.selectedDownloadMinute,
          dataName: _vm.userInputDataName,
        },
        on: {
          visible: _vm.downloadConfirmDialogVisibleFunc,
          success: _vm.successFunc,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }